import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import barba from '@barba/core'
import getScrollbarWidth from 'scrollbar-width'
import { menu } from './_constants'
import { debounce } from './_helpers'

export default function menuTrigger() {
  let headerIsOpened = false
  const menuContent = menu.querySelector('.menu__content')
  const scrollbarWidth = getScrollbarWidth()

  document.addEventListener('click', e => {
    if (e.target.closest('[data-menu]')) {
      document.documentElement.classList.toggle('menu-opened')
      headerIsOpened = !headerIsOpened

      debounce(
        () => {
          headerIsOpened
            ? disableBodyScroll(menuContent)
            : enableBodyScroll(menuContent)

          document.body.style.setProperty(
            '--scrollbarWidth',
            headerIsOpened ? `${scrollbarWidth}px` : 0
          )
        },
        headerIsOpened ? 0 : 2000
      )()
    }
  })

  barba.hooks.leave(() => {
    if (headerIsOpened) {
      document.querySelector('[data-menu]').click()
    }
  })
}
